<template>
  <div class="fixed-content">
    <page-section title="Mentions légales">
      <div class="container-cap">
        <div v-for="(section, k) in content" :key="`section-${k}`">
          <h2>{{ section.title }}</h2>
          <span v-html="section.text"></span>
        </div>
      </div>
    </page-section>
  </div>
</template>
<script>
import pageSection from '@/components/pagesection'
import sc from '@/views/legal/sc/main'

export default {
  name: 'legal',
  computed: {
    content: function () {
      return sc
    }
  },

  components: {
    pageSection
  }
}
</script>
